module.exports = __webpack_public_path__ + "static/media/adv-nick-1.7d6d4035.png";